import {SharedResourceMode} from '../constants';
import {SharedResource} from '../types';

export const filterSharedResourcesByMode = (
	sharedResources: SharedResource[],
	mode?: SharedResourceMode,
) => {
	if (mode == null) return sharedResources;
	return sharedResources.filter((sharedResource) => {
		switch (mode) {
			case SharedResourceMode.CONTRIBUTOR:
				return sharedResource.canEdit;
			case SharedResourceMode.FAVORITE:
				return sharedResource.isFavorite;
			case SharedResourceMode.MANAGER:
				return sharedResource.canManage;
			case SharedResourceMode.VIEWER:
				return true;
		}
	});
};

export default filterSharedResourcesByMode;
